import Cookies from "js-cookie";
import EnvironmentService from "./environmentService";
import {Buffer} from 'buffer';

export default class AuthTokenService {

    constructor() {
        this.environmentService = new EnvironmentService();
        this.clientID = "8yf3mqrwdl8mdgk";
        this.clientSecret = "4nr6et9y8sa6xg6";
    }

    async loginUser(username, password) {
        let formData = new FormData();
        formData.append("grant_type", "password");
        formData.append("username", username);
        formData.append("password", password);

        let result = await fetch(this.environmentService.getAPIEnvironmentHost() + "/api/auth/token",
            {
                headers: {
                    "Authorization": "Basic " + Buffer.from((this.clientID + ":" + this.clientSecret), 'utf-8').toString("base64")
                },
                body: formData,
                method: "POST"
            });
        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json();
            return data;
        }
        else {
            return result;
        }

    }

    async changeUserPassword(oldPassword, newPassword) {

        let changePasswordObject = {
            currentPassword: oldPassword,
            newPassword: newPassword
        }
        let result = await fetch(this.environmentService.getAPIEnvironmentHost() + "/api/auth/changepassword",
            {
                headers: {
                    "Authorization": "Bearer " + Cookies.get("access_token"),
                    "Content-type": "application/json"
                },
                method: "PUT",
                body: JSON.stringify(changePasswordObject)
            });

        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json();
            return data;
        }
        else {
            return result;
        }
    }

    async adminChangeUserPassword(user, newPassword) {
        {
            let changePasswordObject = {
                newPassword: newPassword,
                user: user

            }
            let result = await fetch(this.environmentService.getAPIEnvironmentHost() + "/api/auth/admin/changepassword",
                {
                    headers: {
                        "Authorization": "Bearer " + Cookies.get("access_token"),
                        "Content-type": "application/json"
                    },
                    method: "PUT",
                    body: JSON.stringify(changePasswordObject)
                });

            let responseOK = result && result.ok;
            if (responseOK) {
                let data = await result.json();
                return data;
            }
            else {
                return result;
            }
        }
    }

    async createUser(username, userpassword, userEmail) {
        let createuserObject = {
            UserLoginName: username,
            userpassUserPasswordword: userpassword,
            UserEmail: userEmail
        }

        let result = await fetch(this.environmentService.getAPIEnvironmentHost() + "/api/auth/register",
            {
                headers: {
                    "Authorization": "Bearer " + Cookies.get("access_token"),
                    "Content-type": "application/json"
                },
                method: "POST",
                body: JSON.stringify(createuserObject)
            });

        let responseOK = result && result.ok;

        if (responseOK) {
            let data = await result.json();
            return data;
        }
        else {
            return result;
        }
    }

    async refreshAccessToken(refreshToken) {
        let formData = new FormData();
        formData.append("grant_type", "refresh_token");
        formData.append("refresh_token", refreshToken);
        console.log(refreshToken)

        let result = await fetch(this.environmentService.getAPIEnvironmentHost() + "/api/auth/token",
            {
                headers: {
                    "Authorization": "Basic " + Buffer.from(this.clientID + ":" + this.clientSecret).toString("base64")
                },
                body: formData,
                method: "POST"
            });
        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json();
            return data;
        }
        else {
            return result;
        }
    }
}